// extracted by mini-css-extract-plugin
export var defaultModal = "styles-module--defaultModal--2lws8";
export var modalOverlay = "styles-module--modalOverlay--1XfPo";
export var modalBox = "styles-module--modalBox--3kgm1";
export var fitcontent = "styles-module--fitcontent--2ws8z";
export var small = "styles-module--small--qtX_f";
export var fullscreen = "styles-module--fullscreen--1yNf3";
export var closeBtn = "styles-module--closeBtn--3XWAD";
export var large = "styles-module--large--1i8qs";
export var alertModal = "styles-module--alertModal--27lXA";